import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2dlg0efk02: FaireBrandEntity = {
  token: "b_2dlg0efk02",
  type: "brand",
  name: "Gia Roma",
  avatarUrl:
    "https://cdn.faire.com/fastly/a334cbf8f242260fa9b07cbd7388a31b250b622055c334978736c1dd89e09215.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a457564ca1e70285965db6d55a4095d60b82cfe08b949964cfb1e90f61b4f5d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a334cbf8f242260fa9b07cbd7388a31b250b622055c334978736c1dd89e09215.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a457564ca1e70285965db6d55a4095d60b82cfe08b949964cfb1e90f61b4f5d.jpeg",
  location: "Auburn, NY, USA",
  minimumOrderDollars: 135,
  rating: 4.9,
  reviewCount: 228,
  isTopShop: true,
  isInsider: true,
  description:
    "We embrace the hot mess express lifestyle - Getting through it w/ Coffee, Sarcasm & much more coffee! Relate? You'll LOVE Us! \n\nOur passion is to help others not take life so seriously. Learn how to laugh at imperfections of life vs striving for that IG perfect image & of course help others find pieces for their home that will last, with a focus on eco-friendly & USA made. Make Local, Buy Local & Import Little. oing our part to help the planet & other U.S. Business. A portion of all orders are also made to a local Domestic Abuse Shelter for Women and Children.\n\nA place for all budgets. Whether it be high end products or those looking for a deal. We love good deals & a good splurge on gorgeous products. As most items are USA made, their value is higher.\n\nWe pride ourselves on our amazing customer service & quick turn around times.\nWe are dedicated to giving you the very best when it comes to not only products, but service too. \n\nGia Roma is named after the owner Angela's 2nd child & first Daughter Gia and Roma came from the word Aroma (a play on words with the end of a in Gia and beginning of a in aroma combined). As aroma to us isn't just a smell, but more of an essence and atmosphere.\n\nCreating styles that bring an aroma to the eyes, mind, body, soul, creating memories..an aroma of LIFE.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.779Z",
    importedBy: "entity-db-cli",
  },
};
